const SquashMatchDetailsTypes = {
    GET_SQUASH_MATCH_DETAILS_START:'GET_SQUASH_MATCH_DETAILS_START',
    GET_SQUASH_MATCH_DETAILS_SUCCESS:'GET_SQUASH_MATCH_DETAILS_SUCCESS',
    GET_SQUASH_MATCH_DETAILS_FAILED:'GET_SQUASH_MATCH_DETAILS_FAILED',

}

export default SquashMatchDetailsTypes